import React from 'react';
import PropTypes from 'prop-types';

import { ActionBtn, AlertDialog, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputAdornment from '@material-ui/core/InputAdornment';
import { TextField } from '@material-ui/core';

import { useTheme } from '@material-ui/core/styles';

import { Icons } from '../../../../../common/Icons';
import TopHeader from '../../../../../views/components/TopHeader';
import ValueBox from './ValueBox';

import { storesMng } from '../../../../api/storesMng';

function AdjustUnitRateDialog(props) {
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const { open, onClose, item, onAdjustUnitRate } = props;

  const [newRate, setNewRate] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [openAlertDialog, setOpenAlertDialog] = React.useState(false);

  if (!item) {
    return null;
  }

  const hasNewRate = newRate !== '' && !isNaN(parseFloat(newRate));

  const _onAdjustRate = async () => {
    setLoading(true);
    try {
      await storesMng.storeItem.actions.updateStoreItemAdjustedRate({
        adjustedRateValue: parseFloat(newRate),
        storeItemId: item._id,
      });
      toast.success('Item adjusted rate updated');
      if (onAdjustUnitRate) {
        onAdjustUnitRate();
      }
      onClose();
    } catch (error) {
      console.error('Error adjusting unit rate:', error);
      toast.error('Failed to adjust unit rate');
    } finally {
      setLoading(false);
    }
  };

  const arrowColor = isDark ? '#475569' : '#cbd5e1';

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose} scroll={'body'}>
      <DialogTitle>
        <TopHeader
          title={'Adjust Unit Rate'}
          onClose={onClose}
          icon={<Icons.UnitRate size={20} />}
        />
      </DialogTitle>
      <DialogContent>
        <div style={{ padding: '8px 0 24px' }}>
          <ValueBox type={'current'} item={item} />

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '16px 0',
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2px',
            }}>
              <div style={{
                width: '2px',
                height: '16px',
                backgroundColor: arrowColor,
              }} />
              <div style={{
                width: '0',
                height: '0',
                borderLeft: '6px solid transparent',
                borderRight: '6px solid transparent',
                borderTop: `8px solid ${arrowColor}`,
              }} />
            </div>
          </div>

          <div style={{
            textAlign: 'center',
            marginBottom: '16px',
          }}>
            <TextField
              variant={'outlined'}
              autoFocus
              type={'number'}
              onChange={(event) => {
                setNewRate(event.target.value);
              }}
              value={newRate}
              placeholder={'Enter new unit rate'}
              style={{ maxWidth: '320px' }}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <span style={{ color: isDark ? '#94a3b8' : '#64748b', fontSize: '14px' }}>
                      AED/{item.type.unit}
                    </span>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                style: {
                  fontSize: '22px',
                  textAlign: 'center',
                },
              }}
            />
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '12px 0 16px',
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2px',
            }}>
              <div style={{
                width: '2px',
                height: '16px',
                backgroundColor: arrowColor,
              }} />
              <div style={{
                width: '0',
                height: '0',
                borderLeft: '6px solid transparent',
                borderRight: '6px solid transparent',
                borderTop: `8px solid ${arrowColor}`,
              }} />
            </div>
          </div>

          <ValueBox type={'new'} item={item} newRate={hasNewRate ? parseFloat(newRate) : undefined} />

          <div style={{
            textAlign: 'center',
            marginTop: '32px',
            marginBottom: '16px',
          }}>
            <ActionBtn
              loading={loading}
              disabled={!hasNewRate || loading}
              onClick={() => {
                setOpenAlertDialog(true);
              }}
            />
          </div>
        </div>

        <AlertDialog
          open={openAlertDialog}
          onClose={() => {
            setOpenAlertDialog(false);
          }}
          onConfirm={() => {
            setOpenAlertDialog(false);
            _onAdjustRate();
          }}
          confirmBtn={
            <span style={{ color: '#16a34a' }}>
              Yes, Adjust The Rate
            </span>
          }
          description={'Are you sure you want to modify the item adjusted rate?'}
        />
      </DialogContent>
    </Dialog>
  );
}

AdjustUnitRateDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  item: PropTypes.object,
  onAdjustUnitRate: PropTypes.func,
};

export default AdjustUnitRateDialog;
